import { SETTINGS_AUTOCOMPLETE_KEY } from '../../utility/settingsAccessor.config';
import {
    ctrlIdSelector,
    PLAINTEXT_SELECTOR,
} from '../view/view.attribute.names';

const applyAutocompleteToNode = (node, mode) => {
    if (mode === 'disable') {
        // autocomplete="off" is the "official" way to disable autocomplete but doesn't
        // work in Chrome and possibly other browsers
        // prevailing recommendation is to use new-password to ensure the browser doesn't try to fill it
        // https://stackoverflow.com/a/38961567/1945651
        node.setAttribute('autocomplete', 'new-password');
    }
};

const applyAutocompleteBySelector = (baseNode, selector, mode) => {
    for (const control of baseNode.querySelectorAll(selector)) {
        applyAutocompleteToNode(control, mode);
    }
};

export const applyAutoCompleteSettings = (viewBaseNode, settings) => {
    const { mode: allMode, controls } = settings.getConfig(
        SETTINGS_AUTOCOMPLETE_KEY,
    );

    if (allMode) {
        applyAutocompleteBySelector(viewBaseNode, PLAINTEXT_SELECTOR, allMode);
    }

    for (const [controlId, mode] of Object.entries(controls)) {
        applyAutocompleteBySelector(
            viewBaseNode,
            ctrlIdSelector(controlId),
            mode,
        );
    }
};
